export default __webpack_public_path__ + "static/media/5.4f1727e8.jpg";